import { IoClose, IoCheckmarkCircle } from "react-icons/io5";
import styled from "styled-components";

export const Button = styled.button<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    cursor: ${({ active }) => (!active ? "not-allowed" : "pointer")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
    width: 100%;
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-top: 10px;
`;

export const ValidIcon = styled(IoCheckmarkCircle)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-success, #4caf50);
  font-size: 18px;
`;

export const ContactMeContainer = styled.div`
    position: fixed;
    z-index: 5000;
    left: 0;
    top: 0;
    width: 100%;
    min-height: -webkit-fill-available;
    overflow: auto;
    background-color: #006571;
    max-height: 100vh !important;
    overflow-y: scroll;
    p {
    margin-bottom: 0px;
    }
`;

export const ContactMeContent = styled.div`
    width: 90%;
    text-align: center;
    color: #ffffff;
    margin-left: auto; 
    margin-right: auto;
    @media (min-width: 1024px) { 
        width: 40%;
    }
`;

export const ContactMeHeadline = styled.h2`
    padding-top: 40px;
    color: #ffffff;
`;

export const ContactMeSubtitle = styled.p`
    font-size: 16px;
    margin-top: 18px;
    color: #ffffff;
`;

export const Close = styled.div`
    display: flex;
    justify-content: end;
    padding: 16px;
`;

export const CloseButton = styled.button`
    display: flex;
    float: right;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #ffffff;
    width: 35px;
    height: 35px;
    cursor: pointer;
`;

export const ModalInputContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ModalInput = styled.input<{ isValid?: boolean; isInvalid?: boolean }>`
    padding: 20px 16px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid
      ${({ isValid, isInvalid }) =>
        isValid
          ? "var(--color-success, #4caf50)"
          : isInvalid
          ? "var(--color-alert-color)"
          : "var(--color-grey-100)"};
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);

    &:focus-visible {
        outline: 2px solid
          ${({ isValid }) => (isValid ? "var(--color-success, #4caf50)" : "var(--color-coal)")};
    }
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;

export const ConsentRow = styled.div`
        display: flex;
        align-items: flex-start;
        margin-top: 8px;
        margin-bottom: 24px;
`;

export const ConsentCheckbox = styled.input`
    appearance: none;
    -webkit-appearance: none;
    background: #fff;
    border: 1px solid #F3D2BE;
    border-radius: 5px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
    flex: 0 0 24px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    margin-right: 14px;
    cursor: pointer;
    transition: box-shadow 0.2s;
    &:checked::after {
        content: "✓";
        display: block;
        position: absolute;
        left: 5px;
        color: #d76f2c;
        font-weight: 600;
    }
    &:hover {
        outline: 2px solid #D76F2C;
        outline-offset: 2px;
    }
`;

export const ConsentLabel = styled.label`
        font-size: 12px;
        color: #ffffff;
        cursor: pointer;
        width: 90%;
        text-align: left;
        line-height: 1.45;
`;

export const ConsentLink = styled.a`
        text-decoration: underline;
        color: #ffffff;
`;